import Vue from 'vue';
import Router from 'vue-router';

const Index = () => import('@/pages/Index')
const Login = () => import('@/pages/mine/Login')
const Pwd = () => import('@/pages/mine/Pwd')
const Register = () => import('@/pages/mine/Register')
const EditRegister = () => import('@/pages/mine/EditRegister')
// 协会介绍
const associationIndex = () => import('@/pages/association/index')
// dynamic
const dynamicIndex = () => import('@/pages/dynamic/index')
// news
const newsIndex = () => import('@/pages/news/index')
// laws
const lawsIndex = () => import('@/pages/laws/index')
// contact
const contactIndex = () => import('@/pages/contact/index')
// dangjian
const dangjianIndex = () => import('@/pages/dangjian/index')
// detail
const detailIndex = () => import('@/pages/Detail')
// download
const downloadIndex = () => import('@/pages/Download')
// apply
const applyIndex = () => import('@/pages/Apply')

// train
const trainIndex = () => import('@/pages/train/index')

// list
const listIndex = () => import('@/pages/list/index')

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'app',
      component: Index,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/pwd',
      name: 'pwd',
      component: Pwd,
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
    },
    {
      path: '/editRegister',
      name: 'editRegister',
      component: EditRegister,
    },
    {
      path: '/association',
      name: 'association',
      component: associationIndex,
    },
    {
      path: '/dynamic',
      name: 'dynamic',
      component: dynamicIndex,
    },
    {
      path: '/news',
      name: 'news',
      component: newsIndex,
    },
    {
      path: '/laws',
      name: 'laws',
      component: lawsIndex,
    },
    {
      path: '/contact',
      name: 'contact',
      component: contactIndex,
    },
    {
      path: '/dangjian',
      name: 'dangjian',
      component: dangjianIndex
    },
    {
      path: '/detail',
      name: 'detail',
      component: detailIndex,
    },
    {
      path: '/download',
      name: 'download',
      component: downloadIndex,
    },
    {
      path: '/apply',
      name: 'apply',
      component: applyIndex,
    },
    {
      path: '/train',
      name: 'train',
      component: trainIndex,
    },
    {
      path: '/list',
      name: 'list',
      component: listIndex,
    },
    { 
      　　path: '*', 
      　　component: Index
    }
  ],
});
